<script>
import { HorizontalBar, Charts } from "vue-chartjs";
let colors = ["#006E90", "#FFBC42", "#FF5E5B", "#00CECB", "#B9E6FF"];
let blues = ['#006B8B','#018EC4','#64C0DF','#003E5D','#00609F','#0197D5','#8FCFF2','#012B60','#004E95','#0076BA','#5F86BF','#C0D6ED','#011262','#01267F','#5861A4']
export default {
  extends: HorizontalBar,

  data() {
    return {
      //
      chart_options: {
        legend: {
          position: "bottom",
        },
        title: {
          display: true,
          text: this.title_text,
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                drawBorder: true,
                display: false,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                drawBorder: true,
                display: false,
              },
              ticks: {
                beginAtZero: true,
                stepSize: parseFloat(this.step_size),
                max: parseInt(this.range.max),
                min: 0,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      datas: this.datas_bar,
    };
  },
  mounted() {
    if (this.static_chart_data.labels.length > 0) {
      this.drawBarsGraph(this.static_chart_data);
    }
    if (this.fixedLabelYAxis) {
      (this.chart_options.layout = {
        padding: {
          left: 240,
        },
      }),
        (this.chart_options.scales.yAxes[0].ticks = {
          mirror: true,
          padding: 240,
          callback: function (value) {
            if (value.length > 40) {
              return value.substr(0, 40) + " ...";
            } else {
              return value;
            }
          },
        });
    }
  },

  methods: {
    drawBarsGraph(datas_bar) {
      let componentGraph = this;
      
      
      let count = datas_bar.datasets.length

      let labels = datas_bar.labels;
      
      if(count > 1) {
        datas_bar.datasets.forEach((el, i) => {
          
          el.backgroundColor = colors[i];
          el.borderColor = colors[i];
        });

        let final = { labels, datasets: datas_bar.datasets };
        
        setTimeout(function () {
          componentGraph.renderChart(final, componentGraph.chart_options);
        }, 1000);

      } else {
        
          datas_bar.datasets[0].backgroundColor = blues
          datas_bar.datasets[0].borderColor = blues
        
        let final = { labels, datasets: datas_bar.datasets };
        
        setTimeout(function () {
          componentGraph.renderChart(final, componentGraph.chart_options);
        }, 1000);
      }
      
    },
  },
  props: {
    fixedLabelYAxis: {
      type: Boolean,
      required: false,
      default: false,
    },
    static_chart_data: {
      type: Object,
      required: false,
      default() {
        return {
          labels: [],
          datasets: [],
        };
      },
    },

    range: {
      type: Object,
      required: true,
    },
    step_size: {
      type: Number,
      required: false,
      default: 0.5,
    },
    title_text: {
      type: String,
      required: false,
      default: "Performance",
    },
  },
};
</script>
